import * as React from 'react';
import { Tag } from '../../../models';
import { VideoTag } from './VideoTag';
import './style.css';

export interface VideoTagsProps {
  doNotLinkTags?: boolean;
  tags?: Array<Tag>;
  tooltips?: WeakMap<Tag, string>;
}

export interface VideoTagsState {
  /* empty*/
}

export class VideoTags extends React.Component<VideoTagsProps, VideoTagsState> {
  render() {
    const { doNotLinkTags = false, tags, tooltips } = this.props;

    return (
      <div className="video-tags">
        <ul className="video-tags-list">
          {tags
            ? tags.map(tag => (
                <li className="video-tags-item" key={tag.name}>
                  <VideoTag
                    doNotLinkTag={doNotLinkTags}
                    tag={tag}
                    tooltip={tooltips ? tooltips.get(tag) : undefined}
                  />
                </li>
              ))
            : null}
        </ul>
      </div>
    );
  }
}

export default VideoTags;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoTags/index.tsx